export default "__VITE_PUBLIC_ASSET__fc36ebc0__"